// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__dMLn7","selected":"Chip_selected__zJT8U"};